import { render } from "./Unauthorised.vue?vue&type=template&id=1ff465f5&scoped=true"
import script from "./Unauthorised.vue?vue&type=script&lang=js"
export * from "./Unauthorised.vue?vue&type=script&lang=js"

import "./Unauthorised.vue?vue&type=style&index=0&id=1ff465f5&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff465f5"]])

export default __exports__